import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getPermissionHeirarchyApi } from "../../../service/auth/permissionHeirarchyApi";
import { savePermissionRoleWiseApi } from "../../../service/auth/savePermissionsApi";
import Select from "react-select";
import { getAllRolesApi } from "../../../service/auth/allRolesApi";
import { getPermissions } from "../../../service/auth/permissionsApi";
import { setPermissions } from "../../../feature/permissions";
import { toast } from "react-toastify";
import { Button, Modal } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { findSubMenuByName } from "../propertyList/MenuUtlis";
import { redirectToDash } from "../redirectToDash";

const ManagePermissions = () => {
  const [activeIds, setActiveIds] = useState([]);
  const [permissionData, setPermissionData] = useState([]);
  const [menuItemsState, setMenuItemsState] = useState({});
  const [rolesData,setRolesData]=useState()
const[apiLoading,setApiLoading] = useState(false)
  const dispatch = useDispatch();

  const [selectedField,setSelectedField] = useState()
  const [addMenuItem,setAddMenuItem] = useState(false)

//   setSelectedField({
//     value:res.data?.result?.properties[matchedIndex].Id,
//     label:res.data?.result?.properties[matchedIndex].AddressLine1 + " "+ res.data?.result?.properties[matchedIndex].AddressLine2 + " " +res.data?.result?.properties[matchedIndex].AddressLine3
//   })

  function handleValueSelected(e) {
    console.log(e, "h")
    setSelectedField(e);
  }


const getRoles=()=>{
    dispatch(
        getAllRolesApi((res) => {
          setRolesData(res.data.result)
console.log(res)
        }
    ))
}
useEffect(() => {
  getRoles()
}, [])

  useEffect(() => {
    const payload={
      Roles:[selectedField?.NormalizedName]
    }
 if(selectedField){
  dispatch(
    getPermissionHeirarchyApi(payload, (res) => {
      const data = res.data.result;
      setPermissionData(data);

      const initialMenuItemsState = data.reduce((acc, item) => {
        acc[item.Id] = {
          isChecked: item.IsChecked,
          actions: item.Actions.reduce((a, action) => {
            a[action.ActionId] = action.IsActive;
            return a;
          }, {}),
        };
        return acc;
      }, {});

      setMenuItemsState(initialMenuItemsState);
    })
  );
 }
  }, [selectedField]);

  const handleToggle = (id) => {
    setActiveIds((prevActiveIds) =>
      prevActiveIds.includes(id)
        ? prevActiveIds.filter((activeId) => activeId !== id)
        : [...prevActiveIds, id]
    );
  };

  const handleMenuItemCheckboxToggle = (itemId) => {
    setMenuItemsState((prevState) => {
      const newState = { ...prevState };
      newState[itemId].isChecked = !newState[itemId].isChecked;
      return newState;
    });
  };

  const handleActionCheckboxToggle = (itemId, actionId) => {
    setMenuItemsState((prevState) => {
      const newState = { ...prevState };
      newState[itemId].actions[actionId] = !newState[itemId].actions[actionId];
      return newState;
    });
  };

  const renderActions = (itemId, actions) => {
    return actions.map((action) => (
      <div key={action.ActionId} className="action-item">
        <input
          type="checkbox"
          id={`action-${action.ActionId}`}
          checked={menuItemsState[itemId].actions[action.ActionId]}
          onChange={() => handleActionCheckboxToggle(itemId, action.ActionId)}
        />
        <label htmlFor={`action-${action.ActionId}`}>{action.ActionName}</label>
      </div>
    ));
  };

  const renderMenuItems = (items, parentId = null) => {
    return items
      .filter((item) => item.ParentMenuItemId === parentId)
      .map((item) => {
        const isCheckedValue = menuItemsState[item.Id]?.isChecked || false;

     
        return (
          <div key={item.Id} className="menu-item mb-2">
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                padding: "10px",
                cursor: "pointer",
                backgroundColor: activeIds.includes(item.Id) ? "#ddd" : "#f1f1f1",
                fontWeight: "bold",
              }}
              onClick={() => handleToggle(item.Id)}
            >
              <div>
                <input
                  type="checkbox"
                  checked={isCheckedValue}
                  style={{ marginRight: "10px" }}
                  onClick={(e) => {
                    e.stopPropagation();
                  }}
                  onChange={() => handleMenuItemCheckboxToggle(item.Id)}
                />
                {item.MenuItem}
              </div>
            <div>{activeIds.includes(item.Id) ? "-" : "+"}</div>
            </div>
            {activeIds.includes(item.Id) && (
              <div style={{ padding: "10px", backgroundColor: "#fafafa" }}>
                {item.Actions.length > 0 ? (
                  renderActions(item.Id, item.Actions)
                ) : (
                  <div></div>
                )}
                {renderMenuItems(items, item.Id)}
              </div>
            )}
          </div>
        );
      });
  };

  const getUpdatedPermissionData = () => {
    const updatedPermissionData = permissionData.map((item) => {
      return {
        ...item,
        IsChecked: menuItemsState[item.Id].isChecked,
        Actions: item.Actions.map((action) => ({
          ...action,
          IsActive: menuItemsState[item.Id].actions[action.ActionId],
        })),
      };
    });

    // console.log(updatedPermissionData); // Log to console or handle as needed
    return updatedPermissionData;
  };

  async function handleSavePermsission() {
    const payload={
      permissionHierarchyDTO:await getUpdatedPermissionData(),
      Roles:[selectedField?.NormalizedName]
    }
    console.log(getUpdatedPermissionData())
    // const data = await getUpdatedPermissionData();
    dispatch(savePermissionRoleWiseApi(payload,(res)=>{
if(res.data.statusCode===200){
  toast.success("Permissions updated successfully")
  // const rolePayload={
  //   Roles:selectedField?.NormalizedName
  // }
  // dispatch(getPermissions(rolePayload,(res) => {
  //       dispatch(setPermissions(res?.data?.result))
  //     }))
}
    },()=>{
    }))
  }
  const navigate=useNavigate()
    const { permissions } = useSelector((state) => state.permissionsData);
  
  // Find the "Invoice" menu
  const propertiesMenu = findSubMenuByName(permissions, 'System');
  const listPropertyMenu = propertiesMenu ? findSubMenuByName(propertiesMenu?.SubMenus, 'Manage Permissions') : null;
  useEffect(() => {
    if(!listPropertyMenu){
      redirectToDash(navigate,toast)
    }
  
}, [])

  return (
    <div
      style={{
        width: "100%",
        border: "1px solid #ccc",
        borderRadius: "5px",
        margin: "0 auto",
        background: "white",
        padding: "20px",
      }}
    >
                                    <h4 className="heading me-2 mb-2">Manage Permissions</h4>
                           <div className="mb-4">
                            {/* <button
            className="btn btn-primary"
            style={{
              background: "rgba(233, 133, 35, 0.84)",
              border: "none",
            }}
            onClick={()=>setAddMenuItem(true)}
          >
           Add Menu Item
          </button>
          <button
            className="btn btn-primary"
            style={{
              background: "rgba(233, 133, 35, 0.84)",
              border: "none",
              marginLeft:'5px'
            }}
          >
           Add Menu Action
          </button> */}
<div className="mb-3"/>

                           <Select
                                        // isDisabled={canUpdate?false:true}
                                        value={selectedField}
                                        onChange={handleValueSelected}
                                        placeholder="Select Role Type"
                                        options={rolesData?.map(item => ({
                                          value: item.Id,
                                          label: item.Name,
                                          NormalizedName:item.NormalizedName
                                        }))}
                                      />
                           </div>
      {permissionData.length > 0 ? renderMenuItems(permissionData) : "Please select a role..."}
  
     {permissionData.length > 0  && <button className="btn btn-primary" disabled={apiLoading} onClick={()=>{
      handleSavePermsission()
     
     }} style={{ marginTop: "20px" }}>
   {   apiLoading?"Saving...":"Save Permission"}
      </button>}

      {/* <Modal className="fade" show={addMenuItem} centered>
        <Modal.Header>
          <Modal.Title>Add Menu Item</Modal.Title>
          <Button
            onClick={() => setAddMenuItem(false)}
            variant=""
            className="btn-close"
          ></Button>
        </Modal.Header>
        <Modal.Body>
          <p className="text-black"> 
            Are you sure you want to delete this Invoice ?
          </p>
        </Modal.Body>
        <Modal.Footer>
          <Button
            onClick={() => setAddMenuItem(false)}
            variant="danger light"
          >
            Close
          </Button>
          <Button
            variant="primary"
            // onClick={()=>{handleDeleteConfirm()}}
          >
            Proceed
          </Button>
        </Modal.Footer>
      </Modal> */}
    </div>
  );
};

export default ManagePermissions;
